import type { Metadata, PossibleMetadata } from "shared/util/metadata";
import { createContext, useContext } from "react";
import { mergeMetadata } from "shared/util/metadata";

// Make a context to store the AppConfig object.
const CONTEXT = createContext<Metadata>({ path: "/" });

/**
 * Hook that allows you to use the current app/page context in any component.
 */
export function useMetadata(): Metadata {
	return useContext(CONTEXT);
}

/**
 * Provide the metadata configuration for a page.
 * - The provided context with the current context.
 */
export function MetadataContext({ children, ...metadata }: { children: React.ReactNode } & PossibleMetadata): React.ReactElement {
	return <CONTEXT.Provider value={mergeMetadata(useContext(CONTEXT), metadata)}>{children}</CONTEXT.Provider>;
}
